"use client";

import { useState, useEffect } from "react";

const Selector = ({ items, label, updateTotalQuestions, onChange }) => {
  const [allSelected, setAllSelected] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setAllSelected(checked);
    const newSelectedItems = checked ? items : [];
    setSelectedItems(newSelectedItems);

    const totalQuestions = checked
      ? items.reduce((total, item) => total + item.questionCount, 0)
      : 0;

    const previousTotalQuestions = selectedItems.reduce(
      (total, item) => total + item.questionCount,
      0
    );

    updateTotalQuestions(totalQuestions - previousTotalQuestions);
  };

  const handleItemChange = (item) => {
    const isSelected = selectedItems.includes(item);
    const newSelectedItems = isSelected
      ? selectedItems.filter((s) => s !== item)
      : [...selectedItems, item];

    setSelectedItems(newSelectedItems);
    setAllSelected(newSelectedItems?.length === items?.length);

    const questionDifference = isSelected
      ? -item.questionCount
      : item.questionCount;

    updateTotalQuestions(questionDifference);
  };

  useEffect(() => {
    onChange(selectedItems.map((item) => item._id));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems]);


  return (
    <div className="container mt-4">
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id={`selectAll-${label}`}
          checked={allSelected}
          onChange={handleSelectAll}
        />
        <label className="form-check-label" htmlFor={`selectAll-${label}`}>
          {label}
        </label>
      </div>
      <div id={`${label}List`} className="mt-3 d-flex gap-4 flex-wrap">
        {items.map((item) => (
          <div className="form-check" key={item.displayName}>
            <input
              className="form-check-input subject-checkbox"
              type="checkbox"
              id={item.displayName}
              checked={selectedItems.includes(item)}
              onChange={() => handleItemChange(item)}
            />
            <label className="form-check-label" htmlFor={item.displayName}>
              {item.displayName} ({item.questionCount} questions)
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Selector;
